// units/components/UnitListComponent.tsx
import { FC, useEffect, useState, useRef  } from "react";
import { isArabicCurrentLanguage } from "../../utils";
import { GridTable, LoadingBox, PrivilegesChecker, SearchBox } from "..";
import { ActionTypeEnum, HasFormIdModel, PageEnum,  UnitModel } from "../../models";
import { useSearchBox,useUnitManager } from "../../hooks";

interface UnitListComponentProps extends HasFormIdModel {
   // onActionEvent?: (o: RequestActionModel) => Promise<void>;
    isRefresh?: boolean;
}

/**
 * Component for displaying and managing a list of units
 */
export const UnitList: FC<UnitListComponentProps> = ({
                                                                // onActionEvent,
                                                                  isRefresh = false,
                                                                  formId
                                                              }) => {
    //#region variables
    const isArabic: boolean = isArabicCurrentLanguage();
    const defaultPageSize: number = 50;
    const isInitialMount = useRef(true);
    //#endregion
    //#region hooks
    // Get everything we need directly from the store
    const {
        loading,
        handleActions,
        getAllUnits,
        filterUnits
    } = useUnitManager();
    const {onChange, onSearch, searchedWord, value} = useSearchBox();
//#endregion
    //#region state
    // Local state for the unit list
    const [units, setUnits] = useState<UnitModel[]>([]);
    const [filteredUnits, setFilteredUnits] = useState<UnitModel[]>([]);
//#endregion
    //#region functions
    // Load units function
    const loadUnits = async () => {
        try {
            const unitList = await getAllUnits();
            setUnits(unitList);
            setFilteredUnits(unitList);
        } catch (error) {
            console.error("Error loading units:", error);
        }
    };
    //#endregion
    //#region useEffects
    useEffect(() => {
        const fillData = async () => {
            if (isInitialMount.current) {
                isInitialMount.current = false;
                await loadUnits();
            }
        };
        fillData().then(() => {
        });
    }, []);
    useEffect(() => {
        const fillData = async () => {
            if (!isInitialMount.current && isRefresh) {
                await loadUnits();
                // Use setTimeout to break potential update cycles
                setTimeout(() => {
                    handleActions({action: ActionTypeEnum.Refresh, request: false});
                }, 0);
            }
        };
        fillData().then(() => {
        });
    }, [isRefresh]);
    useEffect(() => {
        const searchValue = searchedWord && searchedWord.trim() !== "" ? searchedWord : value;
        setFilteredUnits(filterUnits(units, searchValue));
    }, [searchedWord, value, units]);
    //#endregion
    //#region html
    return (
        <>
            {loading && <LoadingBox/>}

            {/* Search box */}
            <PrivilegesChecker formId={PageEnum.Units} action="EnableSearch">
                <SearchBox
                    onChangeHandler={onChange}
                    onSearchHandler={onSearch}
                    searchedWord={value}
                    name="name"
                />
            </PrivilegesChecker>

            {/* Units grid */}
            <GridTable
                data={filteredUnits}
                totalRows={filteredUnits.length}
                currentPage={1}
                pageSize={defaultPageSize}
                paginationType="client"
                columnsProps={{
                    actions: [ActionTypeEnum.Update, ActionTypeEnum.Delete],
                    onActionEvent: handleActions,
                    isArabic,
                }}
                formId={formId}
            />
        </>
    );
    //#endregion
};
//export default UnitListComponent;